const SECOND_MS = 1_000;
const MINUTE_MS = 60 * SECOND_MS;
const HOUR_MS = 60 * MINUTE_MS;

export function formatPositionCountdown(
  maturityAt: string,
  nowMs: number,
  language: "zh" | "en"
) {
  const maturityMs = new Date(maturityAt).getTime();
  if (!Number.isFinite(maturityMs)) return "—";
  const remainingMs = Math.max(0, maturityMs - nowMs);
  if (remainingMs === 0) return language === "zh" ? "已到期" : "Matured";

  const totalSeconds = Math.floor(remainingMs / SECOND_MS);
  const days = Math.floor(totalSeconds / 86_400);
  const hours = Math.floor((totalSeconds % 86_400) / 3_600);
  const minutes = Math.floor((totalSeconds % 3_600) / 60);
  const seconds = totalSeconds % 60;
  return language === "zh"
    ? `${days}天${hours}小时${minutes}分${seconds}秒`
    : `${days}d ${hours}h ${minutes}m ${seconds}s`;
}

export function formatShanghaiTimestamp(value: string, language: "zh" | "en") {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "—";
  return new Intl.DateTimeFormat(language === "zh" ? "zh-CN" : "en-GB", {
    timeZone: "Asia/Shanghai",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false
  }).format(date);
}
